import { takeLatest } from 'redux-saga/effects';

import {
  ON_YOUR_TICKET_MOUNT,
  ON_YOUR_TICKET_ERROR
} from '../actions';

import { fetchYourTicketData } from './sagas';
import { redirectToHomepage } from '../../dashboard/actions/sagas';

// Watchers
export function* onYourTicketInit() {
  yield takeLatest(ON_YOUR_TICKET_MOUNT, fetchYourTicketData);
}

export function* redirectToHomepageOnYourTicketMountError() {
  yield takeLatest(ON_YOUR_TICKET_ERROR, redirectToHomepage);
}



// WEBPACK FOOTER //
// ./src/modules/your-ticket/actions/watchers.js